import EDateText from '@/components/everridge/EDateText';
import EInfoModal from '@/components/everridge/EInfoModal';
import SendIcon from '@/components/icons/SendIcon';
import { Button } from '@/components/ui/button';
import { useOwnerInvatationApi } from '@/features/owners/hooks/useOwnerInvatationApi';
import { cn } from '@/lib/utils';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    id: string;
    invitedAt?: Date;
    isMobile?: boolean;
};

const AccountInvitationLogs: FC<Props> = ({ id, invitedAt, isMobile }) => {
    const [showAlertMessage, setShowAlertMessage] = useState(false);
    const { t } = useTranslation();

    const { sendInvitationEmail } = useOwnerInvatationApi();

    const handleSendInvitation = () => {
        sendInvitationEmail(id);
        setShowAlertMessage(false);
    };

    return (
        <>
            <div className="flex h-full flex-col gap-4 select-none">
                <div className="flex items-center justify-between gap-2">
                    <h3 className={cn(isMobile && 'text-base')}>
                        {t('main.account.components.invitation.title')}
                    </h3>
                    <Button
                        variant="outline"
                        size={isMobile ? 'icon' : 'default'}
                        onClick={() => setShowAlertMessage(true)}
                    >
                        <SendIcon />
                        {!isMobile && t('elements.buttons.sendInvitation')}
                    </Button>
                </div>
                <div
                    className={cn(
                        'p-6 flex-1 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
                        isMobile && 'p-0 border-0 bg-popover-30',
                    )}
                >
                    <span className="text-sm font-medium">
                        {invitedAt ? (
                            <>
                                {t('main.account.components.invitation.invitedAt')}:{' '}
                                <EDateText date={invitedAt} />
                            </>
                        ) : (
                            t('main.account.components.invitation.notInvited')
                        )}
                    </span>
                </div>
            </div>
            {showAlertMessage && (
                <EInfoModal
                    label={t('main.owners.components.invitation.sendModal.title')}
                    description={t('main.owners.components.invitation.sendModal.description')}
                    submitName={t('elements.buttons.send')}
                    onSubmit={handleSendInvitation}
                    closeName={t('elements.buttons.cancel')}
                    onClose={() => setShowAlertMessage(false)}
                />
            )}
        </>
    );
};

export default AccountInvitationLogs;
